module.exports = __webpack_public_path__ + "img/fitness_thumbnail-400x300.2cc40530.jpg";